import { c as _c } from "react/compiler-runtime";
import { CdnImage, IMAGE_SIZES } from '@cc-shopping/ui/primitives/CdnImage';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
type ReviewProductCardCardImageProps = {
  source: string;
};
export default function ReviewProductCardCardImage(t0) {
  const $ = _c(4);
  const {
    source
  } = t0;
  const {
    marketplaceEntity: t1
  } = useReviewContext();
  const {
    displayName
  } = t1;
  const t2 = displayName ? `${displayName} Image` : "Product Image";
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      objectFit: "contain",
      objectPosition: "top"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== source || $[2] !== t2) {
    t4 = <CdnImage alt={t2} src={source} fill={true} style={t3} sizes={IMAGE_SIZES.PRODUCT_CARD} />;
    $[1] = source;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
}